import { MarkupItemModel, SubmitGroupItemModel, TextInputModel } from '@libs/form/models';

export const EmailItem: TextInputModel = {
  type: 'email',
  name: 'email',
  label: 'E-Mail-Adresse',
  attributes: {
    autocomplete: 'email',
    required: false,
    spellcheck: false,
    disabled: true,
  },
};

export const MarkupItem: MarkupItemModel = {
  type: 'markup',
  // eslint-disable-next-line max-len
  content: 'Um die E-Mail-Adresse Ihres Benutzerkontos zu ändern, geben Sie bitte unten die neue E-Mail-Adresse an. Unser Support wird die Änderung vornehmen. Sie erhalten eine E-Mail an die neue Adresse, sobald diese hinterlegt ist.',
};

export const EmailNewItem: TextInputModel = {
  type: 'email',
  name: 'emailNew',
  label: 'Neue E-Mail-Adresse',
  hint: '*Pflichtfeld',
  value: '',
  attributes: {
    autocomplete: 'email',
    required: true,
    spellcheck: false,
  },
};

export const EmailConfirmItem: TextInputModel = {
  type: 'email',
  name: 'emailConfirm',
  label: 'Neue E-Mail-Adresse bestätigen',
  hint: '*Pflichtfeld',
  value: '',
  attributes: {
    autocomplete: 'email',
    required: true,
    spellcheck: false,
  },
};

export const SubmitGroupItem: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    {
      name: 'save',
      label: 'Speichern',
      theme: 'outlined',
    },
  ],
};
